/**
 * Parse text for markdown symbols that modify the font
 * @param {string} text - The value of the line (after change)
 * @returns {string} - The string with HTML tags replacing markdown.
 */
export default function replaceMd(
    text: string,
    md: string,
    tags: { open: string; close: string },
): { parsed: string; tag: boolean } {
    let mdEscaped = md;
    if (md === "**") {
        mdEscaped = "\\*\\*";
    }

    const regEx = new RegExp(mdEscaped, "g");

    let appears = 1;
    let tag = false;
    const parsed = text.replaceAll(
        regEx,
        (): string => {
            const replaceWith = appears % 2 === 0 ? tags.close : tags.open;
            appears++;
            tag = true;
            return replaceWith;
        },
    );

    return { parsed, tag };
}